import { FC, useEffect, useState } from "react";
import { createPortal } from "react-dom";
import styles from './customModal.module.scss';

type ModalSize = 'small' | 'large';

interface CustomModalProps {
    message: string;
    isOpen: boolean;
    onClose: () => void;
}

const CustomModal: FC<CustomModalProps> = ({ message, isOpen, onClose }) => {
    const [size, setSize] = useState<ModalSize>('large');

    // 自動調整寬度大小
    useEffect(() => {
        const updateSize = () => {
            setSize(window.innerWidth < 768 ? 'small' : 'large');
        };
        updateSize();
        window.addEventListener('resize', updateSize);
        return () => window.removeEventListener('resize', updateSize);
    }, []);

    // 控制 body 滾動
    useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'auto';
        }

        return () => {
            document.body.style.overflow = 'auto';
        };
    }, [isOpen]);

    // JSX 條件渲染
    const modalContent = isOpen ? (
        <>
            <div className={styles.overlay}></div>
            <div className={styles["main-container"]} style={{ width: size === 'large' ? '520px' : '300px' }}>
                <div className={`title ${size === 'small' ? 'small' : ''}`}>
                    <img
                        className={`alertIcon ${size === 'small' ? 'small' : ''}`}
                        src="/assets/images/modal/alert.png"
                        alt="alertIcon"
                    />
                    提示訊息
                </div>
                <div className={`body ${size === 'small' ? 'small' : ''}`}>
                    <div className={`content ${size === 'small' ? 'small' : ''}`}>{message}</div>
                    <div className="footer">
                        <button onClick={onClose}>我知道了</button>
                    </div>
                </div>
            </div>
        </>
    ) : null;

    // Portal 渲染到 body，確保全螢幕覆蓋
    return createPortal(modalContent, document.body);
};

export default CustomModal;
